const en = {
    // --- Navigation / Menu ---
    nav: {
        home: 'Home',
        aboutUs: 'About Us',
        services: 'Services',
        pages: 'Pages',
        pricing: 'Pricing',
        team: 'Team',
        faq: 'FAQ',
        blog: 'Blog',
        blogList: 'Blog List',
        blogDetail: 'Blog Detail',
        contactUs: 'Contact Us',
        login: 'Login',
    },

    // --- Footer ---
    footer: {
        callNow: 'Call Now',
        aboutUsTitle: 'About Us',
        aboutUsText: 'Pure Key Homes is your trusted partner for property management and guest services. We are dedicated to providing peace of mind, convenience, and professional care for property owners and their guests.',
        contactUsNow: 'Contact Us Now',
        ourLinks: 'Our Links',
        ourServices: 'Our Services',
        propertyManagement: 'Property Management',
        keyHolding: 'Key Holding',
        meetAndGreet: 'Meet & Greet',
        cleaningService: 'Cleaning Service',
        laundryService: 'Laundry Service',
        propertyCheck: 'Property Check',
        contactUsTitle: 'Contact Us',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms Of Service',
        legal: 'Legal',
        copyright: 'Copyright © {{year}} Pure Key Homes. All rights reserved.',
    },

    // --- Home Page ---
    home: {
        bannerTitle: 'Your Property Management in Costa Cálida and Costa Blanca Sur.',
        bannerPlaceholder: 'Email Address or Number Phone...',
        bannerButton: 'I want to be contacted.',
        servicesSubtitle: 'SERVICES',
        servicesTitle: 'What We Provide',
        testimonialSubtitle: 'TESTIMONIAL',
        testimonialTitle: "What Our Client Say's",
        faqSubtitle: 'FAQ',
        faqTitle: 'Common Questions About Property Management',
    },

    // --- Features (Home) ---
    features: {
        subtitle: 'FEATURES',
        title: 'Behind The Story',
        description: 'We are an on site property management team in Costa Cálida and Costa Blanca, offering personalized, reliable, and transparent services to protect your investment and ensure an excellent guest experience.',
        fullPropertyManagement: 'Full Property Management',
        fullPropertyManagementDesc: 'Meet & greet service, continuous guest communication, and full property management between reservations.',
        cleaningAndLaundry: 'Cleaning & Laundry Service',
        cleaningAndLaundryDesc: 'Professional cleaning and laundry between stays',
        guestCommunication: 'Guest Communication 24/7',
        guestCommunicationDesc: 'Guest communication before, during, and after the stay',
        readMore: 'Read More',
    },

    // --- About Blog (Home section) ---
    aboutBlog: {
        subtitle: 'ABOUT US',
        title: 'We Manage Your Property',
        description: 'From the moment a guest arrives to the moment they leave, we handle everything — on site, in person, and with full transparency. So you can enjoy your property without the worry.',
        reservationManagement: 'We manage reservations end to end',
        keyHolding247: 'Secure key holding, available 24/7',
        cleaningService: 'Professional cleaning between every stay',
        laundryService: 'Fresh linens and towels, always ready',
        propertyCheckAlarm: 'Property checks and 24/7 alarm response',
        readMore: 'Read More',
    },

    // --- With Us (CTA banner) ---
    withUs: {
        subtitle: 'Get in Touch with Us',
        title: 'Want to manage your property with confidence? Contact us today and let\'s discuss how we can help.',
        contactUsNow: 'Contact Us Now',
    },

    // --- Services List (Home) ---
    servicesList: {
        propertyManagement: 'Property Management',
        propertyManagementDesc: 'We manage your property with guest communication, check-in/out, cleaning, maintenance, and key holding ensuring your investment is protected',
        meetAndGreet: 'Meet & Greet',
        meetAndGreetDesc: 'We personally welcome your guests, show them around the property, and provide all necessary information for a comfortable stay.',
        cleaningService: 'Cleaning Service',
        cleaningServiceDesc: 'We provide professional cleaning between guest stays, ensuring your property is spotless, hygienic, and ready.',
        laundryService: 'Laundry Service',
        laundryServiceDesc: 'Our laundry service ensures all linens and towels are fresh, clean, and perfectly prepared for each guest.',
        keyHolding: 'Key Holding',
        keyHoldingDesc: 'Secure key management and handover services to ensure smooth check-ins and check-outs for every guest.',
        mortgage: 'Mortgage',
        mortgageDesc: 'Financing for a new property investment.',
        support247: '24x7 Support',
        support247Desc: 'Day or night, we\'re here to manage your property and respond quickly to any situation.',
        webDevelopment: 'Web Development',
        webDevelopmentDesc: 'With our Full Property Management service, we offer a fully personalized website for your property.',
        exploreAllServices: 'Explore All Services',
    },

    // --- Price List ---
    priceList: {
        subtitle: 'PRICING PLAN',
        title: 'Choose Our Plans',
        startingFrom: 'Prices starting from just €15/month — flexible plans tailored to your property needs.',
        getStarted: 'Get Started',
        mostPopular: 'Most Popular',
        keyHolding: 'Key Holding',
        keyHoldingDesc: 'Secure key storage and access management',
        keyHoldingFeatures: ['Secure key storage', '24/7 availability', 'Property access coordination', 'Guest check-in/out', 'Emergency access'],
        propertyManagement: 'Property Management',
        propertyManagementDesc: 'Complete property care',
        propertyManagementFeatures: ['Property inspections', 'Maintenance coordination', 'Emergency response', 'Monthly reports', 'Bill payments'],
        cleaningService: 'Cleaning Service',
        cleaningServiceDesc: 'Professional property cleaning',
        cleaningServiceFeatures: ['Deep cleaning', 'Post-rental cleaning', 'Regular maintenance', 'Eco-friendly products', 'Linen service available'],
        laundryService: 'Laundry Service',
        laundryServiceDesc: 'Professional laundry and linen care',
        laundryServiceFeatures: ['Wash & fold', 'Linen change', 'Iron service', 'Quick turnaround', 'Delivery included'],
    },

    // --- Touch Start (Contact Form) ---
    touchStart: {
        subtitle: 'GET IN TOUCH',
        title: 'Let us manage your property with ease',
        panelSub: 'We are here to help you every step of the way.',
        panelPhone: 'Phone',
        panelEmail: 'Email',
        panelLocation: 'Location',
        panelLocationValue: 'Los Alcazares, Murcia, Spain',
        panelHours: 'Hours',
        panelHoursValue: 'Mon – Sun: 24h/7',
        firstName: 'First Name',
        lastName: 'Last Name',
        emailAddress: 'Email Address',
        phoneNumber: 'Phone Number',
        selectCountryCode: 'Select country code...',
        message: 'Message...',
        submitNow: 'Submit Now',
        submitting: 'Sending...',
        formSuccess: 'Success!',
        formSuccessText: 'Thank you for contacting us! We will get back to you within 24 hours.',
        errorInvalidEmail: 'Please enter a valid email address (e.g., name@example.com)',
        errorInvalidPhone: 'Please enter a valid phone number (6-15 digits)',
        errorRequiredField: 'This field is required',
        errorValidationTitle: 'Please Check Your Information',
        errorValidationMessage: 'Please correct the highlighted errors and try again.',
        errorTitle: 'Unable to Send Message',
        errorMessage: 'We couldn\'t send your message. Please try again or contact us directly by phone or email.',
    },

    // --- Our Blog (Home) ---
    ourBlog: {
        subtitle: 'OUR BLOG',
        title: 'Latest News Feed',
        viewAllNews: 'View All News',
    },

    // --- About Us Page ---
    aboutUsPage: {
        parentPage: 'Home',
        activePage: 'About Company',
        motherMenu: 'About Us',
        testimonialSubtitle: 'TESTIMONIAL',
        testimonialTitle: "What Our Client Say's",
    },

    // --- About Us Content ---
    aboutUsContent: {
        subtitle: 'ABOUT US',
        title: 'Your Trusted Property Management Partner',
        description1: 'Pure Key Homes is a professional property management company based in Costa Cálida and Costa Blanca, Spain. We specialize in providing comprehensive property care services for homeowners, whether you\'re living abroad or simply want peace of mind knowing your property is in expert hands.',
        description2: 'With years of experience in property management, we understand the unique challenges of maintaining a property in Spain. Our multilingual team speaks English, Spanish, and Portuguese, ensuring seamless communication with property owners from around the world.',
        whyChoose: 'Why Choose Us?',
        professionalService: 'Professional Service',
        professionalServiceDesc: 'Experienced team dedicated to maintaining your property to the highest standards',
        availability247: '24/7 Availability',
        availability247Desc: 'Round-the-clock support for emergencies and property access coordination',
        multilingualTeam: 'Multilingual Team',
        multilingualTeamDesc: 'Fluent in English, Spanish, French and Portuguese for seamless communication',
        localExpertise: 'Local Expertise',
        localExpertiseDesc: 'Deep knowledge of Costa Cálida and Costa Blanca property management',
        ourMission: 'Our Mission',
        ourMissionDesc: 'To provide exceptional property management services that give homeowners complete peace of mind, ensuring their properties are maintained, secure, and ready whenever they need them.',
        ourVision: 'Our Vision',
        ourVisionDesc: 'To be the most trusted and reliable property management company in the region, known for our professionalism, transparency, and dedication to customer satisfaction.',
    },

    // --- Counter Blog ---
    counter: {
        guestsHosted: 'Guests Hosted',
        reservationsManaged: 'Reservations Managed',
        propertiesManaged: 'Properties Managed',
        yearsOfExperience: 'Years of Experience',
        starRating: 'Star Rating',
    },

    // --- Story Blog ---
    story: {
        subtitle: 'OUR STORY',
        title: 'The Story of Pure Key Homes',
        theIdea: 'The Idea',
        theIdeaDesc: 'Ana was the manager of a five-star hotel in Lisbon, Portugal, and Pedro was a software developer. During a vacation in La Manga, they quickly fell in love with the quality of life and the region\'s potential. What started as a holiday soon turned into a vision for the future.',
        businessConception: 'Business Conception',
        businessConceptionDesc: 'By combining Ana\'s hospitality expertise with Pedro\'s technological background, they began shaping a professional property management concept. This collaboration marked the official birth of Pure Key Homes.',
        legalSetup: 'Legal & Operational Setup',
        legalSetupDesc: 'The focus shifted to legal compliance, operational processes, and service standards, ensuring that every property would be managed transparently, securely, and professionally.',
        growth: 'Growth & Infrastructure',
        growthDesc: 'With a solid foundation in place, Pure Key Homes expanded its infrastructure, technology, and service network, offering reliable property management from La Manga to Torre de la Horadada.',
    },

    // --- Service Area ---
    serviceArea: {
        subtitle: 'SERVICE AREA',
        title: 'We Operate Across the South Costa Blanca & Costa Cálida',
        specialCoverage: 'With special coverage in:',
    },

    // --- Team Section ---
    teamSection: {
        subtitle: 'OUR TEAM',
        title: 'Meet Our Team',
        ana: 'Ana',
        anaSub: 'CEO',
        pedro: 'Pedro',
        pedroSub: 'Manager & Developer',
        marco: 'Marco',
        marcoSub: 'Key Collaborator',
    },

    // --- Services Page ---
    servicesPage: {
        parentPage: 'Home',
        activePage: 'Our Services',
        motherMenu: 'Services',
        testimonialSubtitle: 'TESTIMONIAL',
        testimonialTitle: "What Our Client Say's",
        close: 'Close',
        // Service card titles & descriptions (used in modal)
        propertyManagement: 'Property Management',
        propertyManagementShort: 'Complete property care and maintenance solutions for your home',
        propertyManagementDetail: 'Our comprehensive property management service ensures your property is maintained to the highest standards. We handle all aspects of property care including regular maintenance, repairs, vendor coordination, and emergency response. Whether you\'re living abroad or simply want peace of mind, our experienced team treats your property as if it were our own, providing detailed reports and updates on all activities.',
        keyHolding: 'Key Holding',
        keyHoldingShort: 'Secure key storage and property access management',
        keyHoldingDetail: 'We provide secure key holding services, ensuring authorized access to your property whenever needed. Our professional team maintains strict security protocols and detailed access logs. We coordinate with contractors, cleaners, and service providers, eliminating the need for you to be present. All keys are stored in a secure, monitored facility with full insurance coverage.',
        meetAndGreet: 'Meet & Greet',
        meetAndGreetShort: 'Professional welcome service for your guests and visitors',
        meetAndGreetDetail: 'Make a great first impression with our personalized meet and greet service. We welcome your guests, provide property orientation, hand over keys, and ensure they have everything they need for a comfortable stay. Our multilingual team can communicate in English, Spanish, and Portuguese, making your guests feel at home from the moment they arrive. We can also provide local recommendations and assistance throughout their stay.',
        cleaningService: 'Cleaning Service',
        cleaningServiceShort: 'Professional cleaning services for your property',
        cleaningServiceDetail: 'Our thorough cleaning service ensures your property is spotless and welcoming. We offer regular cleaning schedules, deep cleaning, and turnover cleaning between guests. Our experienced cleaning team uses high-quality products and follows detailed checklists to ensure every corner is attended to. We can customize our cleaning service to meet your specific requirements and schedule.',
        laundryService: 'Laundry Service',
        laundryServiceShort: 'Complete laundry and linen care services',
        laundryServiceDetail: 'We provide comprehensive laundry services including washing, drying, ironing, and fresh linen preparation. Our service ensures your property always has clean, fresh bedding and towels ready for guests or your next visit. We use professional-grade equipment and premium detergents to maintain the quality of your linens. We can also handle curtains, cushion covers, and other soft furnishings.',
        propertyCheck: 'Property Check',
        propertyCheckShort: 'Regular property inspections and monitoring',
        propertyCheckDetail: 'Our property check service includes regular inspections to identify and address potential issues before they become problems. We check for water leaks, electrical issues, security concerns, and general maintenance needs. Each visit includes a detailed report with photos, giving you complete visibility of your property\'s condition. We can schedule checks weekly, monthly, or as needed based on your preferences.',
        alarmResponse: 'Alarm Response',
        alarmResponseShort: '24/7 emergency alarm response service',
        alarmResponseDetail: 'Our alarm response service provides immediate action when your property alarm is triggered. Available 24/7, our team will attend your property, liaise with security companies and emergency services, and take appropriate action to secure your property. We provide full incident reports and coordinate any necessary repairs or security measures. Your property\'s safety is our top priority.',
        registerGuests: 'Register Guests',
        registerGuestsShort: 'Guest registration and check-in assistance',
        registerGuestsDetail: 'We handle all aspects of guest registration including official check-in procedures, documentation, and local authority reporting as required by Spanish law. Our service ensures compliance with all legal requirements while providing a smooth, professional check-in experience for your guests. We maintain detailed records and can provide you with guest information and statistics.',
        upholsteryCleaning: 'Upholstery Cleaning',
        upholderyCleaningShort: 'Deep cleaning for furniture and upholstery',
        upholsteryCleaningDetail: 'Our specialized upholstery cleaning service revitalizes your furniture, removing stains, odors, and allergens. We use professional equipment and techniques suitable for different fabrics and materials. This service extends the life of your furniture and maintains a fresh, clean environment. We can also treat outdoor furniture, mattresses, and carpets with the same level of care and expertise.',
        mortgageServices: 'Mortgage Services',
        mortgageServicesShort: 'Assistance with Spanish mortgage and financial services',
        mortgageServicesDetail: 'Navigate the Spanish mortgage market with our expert guidance. We connect you with trusted financial advisors and mortgage brokers who understand the unique requirements for foreign property owners. Our service includes assistance with documentation, translation of financial terms, and coordination with banks and legal representatives. We help make the mortgage process straightforward and transparent.',
        support247: '24x7 Support',
        support247Short: 'Round-the-clock availability for all your needs',
        support247Detail: 'Our commitment to you doesn\'t stop at office hours. We provide 24/7 support for emergencies, urgent requests, and peace of mind. Whether it\'s a maintenance emergency, guest issue, or simply a question, our team is always available to help. We maintain multiple communication channels including phone, email, and WhatsApp to ensure you can always reach us when you need us.',
    },

    // --- Pricing Page ---
    pricingPage: {
        parentPage: 'Home',
        activePage: 'Our Pricing',
        motherMenu: 'Pricing',
        testimonialSubtitle: 'TESTIMONIAL',
        testimonialTitle: "What Our Client Say's",
    },

    // --- Team Page ---
    teamPage: {
        parentPage: 'Home',
        activePage: 'Our Team',
        motherMenu: 'Team',
        testimonialSubtitle: 'TESTIMONIAL',
        testimonialTitle: "What Our Client Say's",
    },

    // --- FAQ Page ---
    faqPage: {
        parentPage: 'Home',
        activePage: 'FAQ',
        motherMenu: 'FAQ',
        subtitle: 'FAQ',
        title: 'Frequently Asked Questions',
        faq2Subtitle: 'FAQ',
        faq2Title: 'Property Management Guide',
        faq2Desc: 'Everything you need to know about managing your property with Pure Key Homes.',
        categoryGeneral: 'General Property Management',
        categoryServices: 'Guest Services & Management',
        categoryPricing: 'Getting Started & Pricing',
        testimonialSubtitle: 'TESTIMONIAL',
        testimonialTitle: "What Our Clients Say",

        // General Property Management
        q1: 'What areas do you cover?',
        a1: 'We operate across Costa Cálida and Costa Blanca, with special coverage in Los Alcázares, Torre Pacheco, San Javier, Santiago de la Ribera, La Manga, Pilar de la Horadada, and Torre de la Horadada.',

        q2: 'What services are included in full property management?',
        a2: 'Our full property management includes guest communication before, during and after their stay, meet & greet service, key holding, professional cleaning and laundry between stays, property checks, maintenance coordination, 24/7 emergency support, and detailed reporting.',

        q3: 'How do you handle emergencies?',
        a3: 'We provide 24/7 emergency response service. Our on-site team can attend your property immediately for urgent situations like water leaks, electrical issues, or security concerns. We coordinate with local emergency services and contractors as needed and keep you informed throughout.',

        q4: 'Can I customize the services I need?',
        a4: 'Absolutely! We offer flexible service packages. Whether you need just key holding, cleaning between guests, or full property management, we can tailor our services to match your specific requirements and budget.',

        q5: 'How often will you inspect my property?',
        a5: 'For rental properties, we inspect before and after each guest stay. For non-rental properties, we can schedule regular checks weekly, bi-weekly, or monthly based on your preference. Each inspection includes a detailed report with photos.',

        // Guest & Rental Management
        q6: 'Do you handle guest check-in and check-out?',
        a6: 'Yes! We provide a personal meet & greet service, welcoming guests on arrival, showing them the property, explaining how everything works, and being available throughout their stay. We also handle check-out inspections and key collection.',

        q7: 'What languages does your team speak?',
        a7: 'Our multilingual team speaks English, Spanish, Portuguese, and French, ensuring smooth communication with property owners and guests from around the world.',

        q8: 'Do you manage reservations from platforms like Airbnb and Booking.com?',
        a8: 'Yes, we can manage your listings on all major platforms including Airbnb, Booking.com, and Vrbo. We handle guest communication, calendar synchronization, pricing optimization, and ensure compliance with all platform requirements.',

        // Cleaning & Maintenance
        q9: 'What does your cleaning service include?',
        a9: 'Our professional cleaning includes thorough cleaning of all rooms, kitchen appliances, bathrooms, floors, surfaces, window cleaning, and rubbish removal. We also provide fresh linens and towels, and ensure the property is guest-ready with all amenities stocked.',

        q10: 'How quickly can you arrange maintenance or repairs?',
        a10: 'We work with trusted local contractors and can typically arrange urgent repairs within 24 hours. For non-urgent maintenance, we coordinate with you first and provide quotes before proceeding. All work is supervised and documented.',

        // Getting Started
        q11: 'How do I get started?',
        a11: 'Simply contact us via phone, email, or our website contact form. We\'ll schedule a meeting to discuss your needs, visit your property, and create a customized service plan. We can typically onboard new properties within 48 hours.',

        q12: 'Is there a contract or minimum commitment?',
        a12: 'We offer flexible agreements based on your needs. For full property management, we typically work with quarterly agreements. For individual services like cleaning or key holding, no long-term commitment is required.',

        q13: 'How will I receive reports about my property?',
        a13: 'You\'ll receive detailed reports via email after each property check, guest stay, or maintenance visit. Reports include photos, notes on property condition, any issues found, and actions taken. You can also request updates anytime.',

        q14: 'What are your service fees?',
        a14: 'Our pricing depends on the services you need and your property size. We offer transparent, competitive rates with no hidden fees. Contact us for a personalized quote based on your specific requirements.',

        q15: 'Are you insured and licensed?',
        a15: 'Yes, we are fully insured and operate in compliance with all Spanish property management regulations. We maintain professional liability insurance and work with licensed contractors for all specialized services.',
    },

    // --- Blog List Page ---
    blogListPage: {
        parentPage: 'Home',
        activePage: 'Our Blog',
        motherMenu: 'Blog',
    },

    // --- Blog Detail Page ---
    blogDetailPage: {
        parentPage: 'Home',
        activePage: 'Blog Detail',
        motherMenu: 'Blog',
        relatedBlog: 'Related Blog',
        relatedBlogSubtitle: 'OUR BLOG',
        postReview: 'POST REVIEW',
        comments: 'Comments',
        reply: 'Reply',
        replyNow: 'REPLY NOW',
        leaveAReply: 'Leave A Reply',
        firstName: 'First Name',
        lastName: 'Last Name',
        emailAddress: 'Email Address',
        message: 'Message',
        postNow: 'Post Now',
        tag: 'Tag:',
        formSuccess: 'Good job!',
        formSuccessText: 'form successfully submitted',
    },

    // --- Contact Page ---
    contactPage: {
        parentPage: 'Home',
        activePage: 'Contact Us',
        motherMenu: 'Contact Us',
        callNow: 'Call Now',
        location: 'Location',
        emailAddress: 'Email Address',
    },

    // --- Blog Sidebar ---
    blogSidebar: {
        search: 'Search',
        searchPlaceholder: 'Search...',
        recentPost: 'Recent Post',
        category: 'Category',
        advertising: 'Advertising',
        tags: 'Tags',
        gallery: 'Gallery',
    },

    // --- Blog Card / OurBlogBox ---
    blogCard: {
        readMore: 'READ MORE',
    },

    // --- Login Page ---
    loginPage: {
        backToSite: 'Back to Site',
        welcomeBack: 'Welcome Back',
        signInToAccount: 'Sign in to your account',
        continueWithGoogle: 'Continue with Google',
        continueWithMicrosoft: 'Continue with Microsoft',
        or: 'OR',
        loginWithEmail: 'Login with Email & Password',
        emailAddress: 'Email Address',
        password: 'Password',
        forgotPassword: 'Forgot password?',
        signIn: 'Sign In',
        signingIn: 'Signing In...',
    },
};

export default en;
